export const SESSION_STORAGE_KEY = "abb_tracking";

export const ANON_ID_URL_PARAM = "anon_id";

export const TRACKING_URL_KEYS = [
  ANON_ID_URL_PARAM,
  "applied_product",
  "applied_product_origin",
  "touches",
  "first_touch",
  "last_touch",
  "touch_count",
  "touches_truncated"
] as const;

export function isStrippedQueryParam(key: string): boolean {
  return (
    key.startsWith("utm_") ||
    (TRACKING_URL_KEYS as readonly string[]).includes(key)
  );
}

export function hasStripableQueryParams(params: URLSearchParams): boolean {
  for (const key of params.keys()) {
    if (isStrippedQueryParam(key)) {
      return true;
    }
  }

  return false;
}
